import { Modal } from "antd";
import { Flex } from "@chakra-ui/react";
import { CloseModalButton } from "components/Button/CloseModalButton";
import FormItemCategoriaFinanceira from "./FormItemCategoriaFinanceira";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import { ComposicaoItem } from "core/features/conta/typings";
import { useForm } from "react-hook-form";
import { useEffect } from "react";

interface ModalComposicaoContaProps {
  isOpen: boolean;
  onClose: () => any;
  onSubmit: (item: ComposicaoItem) => any;
  operacao: any;
}

const defaultValues: ComposicaoItem = {
  categoriaFinanceiraId: "",
  valor: 0,
  operacao: 1,
};

function ModalComposicaoConta({
  isOpen,
  onClose,
  onSubmit,
  operacao,
}: ModalComposicaoContaProps) {
  const { control, reset, handleSubmit, setValue } = useForm<ComposicaoItem>({
    defaultValues,
  });

  useEffect(() => {
    if (!isOpen) {
      reset(defaultValues);
    }
  }, [isOpen, reset]);

  return (
    <Modal
      centered
      visible={isOpen}
      footer={
        <Flex justifyContent="end">
          <CloseModalButton close={onClose} closeModalLabel="Cancelar" />
          <PrimaryButton ml={5} mr={2} onClick={handleSubmit(onSubmit)}>
            Adicionar
          </PrimaryButton>
        </Flex>
      }
      title="Adicionar conta categoria"
      destroyOnClose
      onCancel={onClose}
      closable={true}
      width={"min(600px, 60vw)"}
      bodyStyle={{
        maxHeight: "80vh",
        overflow: "auto",
        overflowX: "hidden",
        paddingBottom: 16,
      }}
    >
      <FormItemCategoriaFinanceira
        operacao={operacao}
        control={control}
        setValue={setValue}
      />
    </Modal>
  );
}

export default ModalComposicaoConta;
